<script setup>
    import { reactive } from 'vue';
    import { router } from '@inertiajs/vue3';

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        areas: Array,
        statuses: Array,
        themes: Array,
        sdgs: Array,
        loggedInUserId: Number,
    });

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    // Set up widget variables
    const actions = props.actions;
    const starredActions = reactive([]);

    // Are there any actions to view?
    if (actions) {

        // Loop through each action and push any starred action to starredActions
        actions.forEach(function (action) {
            if ( action.action_starred.length !== 0 && action.action_starred[0] !== 0 ) {
                starredActions.push(action);
            }
        });

        // Loop through starredActions and add new properties and values
        // These are status labels and status classes
        starredActions.forEach(function (starredAction) {
            // create ID to link to on Toolkit page
            starredAction.actionID = starredAction.reference.toLowerCase();
            const starredActionID = starredAction.actionID.replace(/\s/g, '');
            starredAction.actionLink = route(urlNamePrefix+'toolkit.view') + '#' + starredActionID;

            if ( starredAction.actionCurrentStatus.length !== 0 ) {
                if ( starredAction.actionCurrentStatus[0] == 1 ) {
                    starredAction.actionCurrentStatusLabel ='done';
                    starredAction.actionCurrentStatusClass = 'action-done';
                }
                else if ( starredAction.actionCurrentStatus[0] == 2 ) {
                    starredAction.actionCurrentStatusLabel = 'in_progress';
                    starredAction.actionCurrentStatusClass = 'action-in-progress';
                }
                else if ( starredAction.actionCurrentStatus[0] == 3 ) {
                    starredAction.actionCurrentStatusLabel = 'not_done';
                    starredAction.actionCurrentStatusClass = 'action-not-done';
                }
                else if ( starredAction.actionCurrentStatus[0] == 4 ) {
                    starredAction.actionCurrentStatusLabel = 'not_applicable';
                    starredAction.actionCurrentStatusClass = 'action-not-applicable';
                }
            }
            else {
                starredAction.actionCurrentStatusLabel = 'none';
                starredAction.actionCurrentStatusClass = 'action-no-status';
            }
        });
    }

</script>

<template>
    <div class="dashboard-widget widget actions-starred-widget" v-if="starredActions">
        <div class="flex justify-between widget-header">
            <span>{{ $t('dashboard.widgets.starred.title') }}</span>
            <span class="material-icons-outlined">star_outline</span>
        </div>
        <div class="widget-content">
            <ul v-if="starredActions.length">
                <li v-for="starredAction in starredActions" class="action-starred-item" :class="starredAction.actionCurrentStatusClass">
                    <a :href="starredAction.actionLink">
                    <span class="flex items-center">
                        <span class="material-icons-outlined">star</span>
                        <span class="action-name">{{ starredAction.reference }}</span>
                    </span>
                    <span class="action-status" :class="starredAction.actionCurrentStatusClass">{{ $t('dashboard.widgets.shared.status.' + starredAction.actionCurrentStatusLabel) }}</span>
                </a>
                </li>
            </ul>
            <div v-else>
                <p>{{$t('dashboard.widgets.starred.empty')}}</p>
            </div>
        </div>
    </div>
</template>
